<div class="filter">
  <form [formGroup]="form" (ngSubmit)="onSubmitFilter()">
    <fieldset>
      <div class="filter-top">
        <p [innerHTML]="'TERM.FILTER' | t">Filter</p>
      </div>
      <div class="filter-content">
        <ul>
          <li id="filter-sort">
            <div (click)="list.classList.toggle('active')">
              <p class="filter-txt" [innerHTML]="'FILTER_SECTION.SORT' | t">Sort</p>
              <span class="icon" [class.open]="list.classList.contains('active')"></span>
            </div>
            <div class="sort group" #list [style.display]="list.classList.contains('active') ? 'block' : 'none'">
              <mat-radio-group aria-labelledby="order-by-radio-label" formControlName="orderBy">
                @for (order of ORDER_BY; track order) {
                  @if (order.key === 'FILTERED_PRODUCT_LIST.SORT.MATCH_SCORE' && filterType === SEARCH_TYPE.SEARCH) {
                    <mat-radio-button class="radio-button" [value]="order">
                      {{ order?.key | t }}
                    </mat-radio-button>
                  }
                }
                @for (order of ORDER_BY; track order) {
                  @if (order.key !== 'FILTERED_PRODUCT_LIST.SORT.MATCH_SCORE') {
                    <mat-radio-button class="radio-button" [value]="order">
                      {{ order.key | t }}
                    </mat-radio-button>
                  }
                }
              </mat-radio-group>
            </div>
          </li>
          @if (filterType !== 'CATEGORY' && allDisplayCategories) {
            <li id="filter-category">
              <div (click)="list1.classList.toggle('active')">
                <p class="filter-txt" [innerHTML]="'FILTER_SECTION.CATEGORY' | t">Category</p>
                <span class="icon" [class.open]="list1.classList.contains('active')"></span>
              </div>
              <div
                class="category group"
                #list1
                [style.display]="list1.classList.contains('active') ? 'block' : 'none'"
              >
                <mat-checkbox
                  class="checkbox"
                  [ngModelOptions]="{ standalone: true }"
                  [(ngModel)]="isSelectedAllCategory"
                  (change)="onUncheckedCategoryAll()"
                >
                  <span [innerHTML]="'TERM.ALL' | t"> All </span>
                </mat-checkbox>
                @for (depth1 of selected.displayCategoryTree.children; track depth1) {
                  <div class="depth-1">
                    <mat-checkbox
                      class="checkbox"
                      [ngModelOptions]="{ standalone: true }"
                      [(ngModel)]="depth1.selected"
                      (change)="onToggleCategory(depth1, $event)"
                    >
                      <span>
                        {{ depth1.item.name }}
                      </span>
                    </mat-checkbox>
                    <span
                      class="icon category"
                      [class.active]="depth1.unfolded === true"
                      (click)="depth1.unfolded = !depth1.unfolded"
                    ></span>
                  </div>
                  @for (depth2 of depth1.children; track depth2) {
                    @if (depth1?.children.length > 0) {
                      <div class="depth-2" [ngClass]="{ active: depth1.unfolded === true }">
                        <mat-checkbox
                          class="checkbox"
                          [ngModelOptions]="{ standalone: true }"
                          [(ngModel)]="depth2.selected"
                          (change)="onToggleCategory(depth2, $event)"
                        >
                          <span>
                            {{ depth2.item.name }}
                          </span>
                        </mat-checkbox>
                        @if (depth2?.children.length > 0) {
                          <span
                            class="icon category"
                            [class.active]="depth2.unfolded === true"
                            (click)="depth2.unfolded = !depth2.unfolded"
                          ></span>
                        }
                      </div>
                    }
                    @if (depth2.children.length > 0) {
                      @for (depth3 of depth2.children; track depth3) {
                        <div class="depth-3" [class.active]="depth2.unfolded === true">
                          <mat-checkbox
                            class="checkbox"
                            [ngModelOptions]="{ standalone: true }"
                            [(ngModel)]="depth3.selected"
                            (change)="onToggleCategory(depth3, $event)"
                          >
                            <span>
                              {{ depth3.item.name }}
                            </span>
                          </mat-checkbox>
                        </div>
                      }
                    }
                  }
                }
              </div>
            </li>
          }
          @if (filterType !== 'BRAND') {
            <li id="filter-brand">
              <div (click)="list2.classList.toggle('active')">
                <p class="filter-txt" [innerHTML]="'FILTER_SECTION.BRAND' | t">Brand</p>
                <span class="icon" [class.open]="list2.classList.contains('active')"></span>
              </div>
              <div class="brand group" #list2 [style.display]="list2.classList.contains('active') ? 'block' : 'none'">
                <mat-checkbox
                  class="checkbox"
                  [ngModelOptions]="{ standalone: true }"
                  [(ngModel)]="isSelectedAllBrand"
                  (change)="onUncheckedBrandAll()"
                >
                  <span [innerHTML]="'TERM.ALL' | t"> All </span>
                </mat-checkbox>
                @for (brand of selected.brands; track brand) {
                  <mat-checkbox
                    class="checkbox"
                    [ngModelOptions]="{ standalone: true }"
                    [(ngModel)]="brand.selected"
                    (change)="onToggleBrand(brand, $event)"
                  >
                    <span>
                      {{ brand.englishName }}
                    </span>
                  </mat-checkbox>
                }
              </div>
            </li>
          }
          <li id="filter-price">
            <div (click)="list3.classList.toggle('active')">
              <p class="filter-txt" [innerHTML]="'FILTER_SECTION.PRICE_RANGE' | t">Price Range</p>
              <span class="icon" [class.open]="list3.classList.contains('active')"></span>
            </div>
            <div class="price group" #list3 [style.display]="list3.classList.contains('active') ? 'block' : 'none'">
              <mat-radio-group
                class="radio-field"
                [(ngModel)]="selected.priceType"
                [ngModelOptions]="{ standalone: true }"
                (change)="onResetPriceRangeValue()"
              >
                <div>
                  <mat-radio-button type="radio" class="radio-button" [value]="PRICE_TYPE.ALL">
                    <span [innerHTML]="'TERM.ALL' | t"> All </span>
                  </mat-radio-button>
                </div>
                <div>
                  <mat-radio-button class="radio-button" [value]="PRICE_TYPE.PRICE">
                    <p>{{ 'TERM.PRICE' | t }} (USD)</p>
                  </mat-radio-button>
                  <fieldset>
                    <div class="field min-max radio-form">
                      <div>
                        <label>
                          <input
                            type="text"
                            mask="0{5}"
                            placeholder="{{ 'TERM.MIN_PRICE' | t }}"
                            formControlName="minPrice"
                            maxlength="5"
                            (focus)="selected.priceType = PRICE_TYPE.PRICE; onResetPriceRangeValue()"
                          />
                        </label>
                      </div>
                      <span class="dash">~</span>
                      <div>
                        <label>
                          <input
                            type="text"
                            mask="0{5}"
                            placeholder="{{ 'TERM.MAX_PRICE' | t }}"
                            formControlName="maxPrice"
                            maxlength="5"
                            (focus)="selected.priceType = PRICE_TYPE.PRICE; onResetPriceRangeValue()"
                          />
                        </label>
                      </div>
                    </div>
                  </fieldset>
                </div>
                <div>
                  <mat-radio-button class="radio-button" [value]="PRICE_TYPE.SUPPLY_RATE">
                    <p>{{ 'TERM.SUPPLY_RATE' | t }} (%)</p>
                  </mat-radio-button>
                  <fieldset>
                    <div class="field min-max radio-form">
                      <div>
                        <label>
                          <input
                            type="text"
                            mask="00"
                            placeholder="{{ 'TERM.MIN_RATE' | t }}"
                            formControlName="minRate"
                            maxlength="2"
                            (focus)="selected.priceType = PRICE_TYPE.SUPPLY_RATE; onResetPriceRangeValue()"
                          />
                        </label>
                      </div>
                      <span class="dash">~</span>
                      <div>
                        <label>
                          <input
                            type="text"
                            mask="00"
                            placeholder="{{ 'TERM.MAX_RATE' | t }}"
                            formControlName="maxRate"
                            maxlength="2"
                            (focus)="selected.priceType = PRICE_TYPE.SUPPLY_RATE"
                          />
                        </label>
                      </div>
                    </div>
                  </fieldset>
                </div>
              </mat-radio-group>
            </div>
          </li>
          <li id="filter-moq" #list4>
            <div (click)="list4.classList.toggle('active')">
              <p class="filter-txt" [innerHTML]="'FILTER_SECTION.MOQ' | t">MOQ</p>
              <span class="icon" [class.open]="list4.classList.contains('active')"></span>
            </div>
            <div class="moq group" list4 [style.display]="list4.classList.contains('active') ? 'block' : 'none'">
              <p class="txt" [innerHTML]="'FILTERED_PRODUCT_LIST.MIN_MAX_QUANTITY' | t">
                Minimum/Maximum Order Quality (ea)
              </p>
              <fieldset>
                <div class="field min-max">
                  <div>
                    <label>
                      <input
                        type="text"
                        maxlength="5"
                        mask="0{5}"
                        placeholder="{{ 'TERM.MIN_MOQ' | t }}"
                        formControlName="minMoq"
                      />
                    </label>
                  </div>
                  <span class="dash">~</span>
                  <div>
                    <label>
                      <input
                        type="text"
                        maxlength="5"
                        mask="0{5}"
                        placeholder="{{ 'TERM.MAX_MOQ' | t }}"
                        formControlName="maxMoq"
                      />
                    </label>
                  </div>
                </div>
              </fieldset>
            </div>
          </li>
          <li id="filter-moa" #list5>
            <div (click)="list5.classList.toggle('active')">
              <p class="filter-txt" [innerHTML]="'FILTER_SECTION.MOA' | t">MOA</p>
              <span class="icon" [class.open]="list5.classList.contains('active')"></span>
            </div>
            <div class="moq group" list5 [style.display]="list5.classList.contains('active') ? 'block' : 'none'">
              <p class="txt" [innerHTML]="'FILTERED_PRODUCT_LIST.MIN_MAX_AMOUNT' | t">Minimum/Maximum Order Amount</p>
              <fieldset>
                <div class="field min-max">
                  <div>
                    <label>
                      <input
                        type="text"
                        maxlength="5"
                        mask="0{5}"
                        placeholder="{{ 'TERM.MIN_MOQ' | t }}"
                        formControlName="minMoa"
                      />
                    </label>
                  </div>
                  <span class="dash">~</span>
                  <div>
                    <label>
                      <input
                        type="text"
                        maxlength="5"
                        mask="0{5}"
                        placeholder="{{ 'TERM.MAX_MOQ' | t }}"
                        formControlName="maxMoa"
                      />
                    </label>
                  </div>
                </div>
              </fieldset>
            </div>
          </li>
          <li id="filter-certification" #list6>
            <div (click)="list6.classList.toggle('active')">
              <p class="filter-txt">Certification</p>
              <span class="icon" [class.open]="list6.classList.contains('active')"></span>
            </div>
            <div class="brand group" #list6 [style.display]="list6.classList.contains('active') ? 'block' : 'none'">
              @for (certificationType of certificationTypes; track certificationType) {
                <mat-checkbox
                  class="checkbox"
                  [ngModelOptions]="{ standalone: true }"
                  [(ngModel)]="certificationType.selected"
                >
                  <span>
                    {{ certificationType.value }}
                  </span>
                </mat-checkbox>
              }

              <mat-checkbox class="checkbox" [ngModelOptions]="{ standalone: true }" [(ngModel)]="isCpnp">
                <span> CPNP </span>
              </mat-checkbox>
            </div>
          </li>
        </ul>
      </div>
      <div class="submit cancel-n-done">
        <button type="button" (click)="onResetForm()" [innerHTML]="'BUTTON.RESET' | t">RESET</button>
        <button type="submit" [innerHTML]="'BUTTON.DONE' | t">DONE</button>
      </div>
    </fieldset>
  </form>
</div>
